/* eslint-disable */

const ohsaaAccountId = 'rfmi1dfxlhtqp69l9jgp';
const ohsaaChannelId = 'giujawrivhus63h3llqf';
const spectrumAccountId = 'omlfvqvbfpmptp5lg4vo';
const spectrumChannelid = 'gslsjbxbxopgb8rpilyn';

const config = {
  accountId: spectrumAccountId,
  channelId: spectrumChannelid,
  channelFilter: (c) => {
    return true
  },
  staticChannels: [
  ],
  accountIdMap: {
    'omlfvqvbfpmptp5lg4vo': 'gslsjbxbxopgb8rpilyn',
    'rfmi1dfxlhtqp69l9jgp': 'giujawrivhus63h3llqf',
  },
  spectrumAccountId: spectrumAccountId,
}

const spectrumChannels = {
    /*'d2olomy0a8wmumulaetu': {
      name: 'Press Conference',
      price: 0,
      price_suffix: '',
      geoblocked: false,
      preview: '',
      label: 'Press Conference',
      highlight: true,
    },*/
    'gslsjbxbxopgb8rpilyn': {
      name: 'Football',
      price: 9.99,
      price_suffix: 'game',
      geoblocked: false,
      preview: '/img/icon_football.png',
      label: 'Football',
      highlight: true,
    },
    'qhqbi2ps2wz5kmzkvpa7': {
      name: 'Lacrosse',
      price: 9.99,
      price_suffix: 'game',
      geoblocked: false,
      preview: '/img/icon_lacrosse.png',
      label: 'Lacrosse',
      highlight: true,
    },
    'k1oj2kqhf10ptgukpmpa': {
      name: 'Baseball',
      price: 9.99,
      price_suffix: 'game',
      geoblocked: false,
      preview: '/img/icon_baseball.png',
      label: 'Baseball',
      highlight: true,
    },
    'xzcvrbkafrpdyko4lpr5': {
      name: 'Softball',
      price: 9.99,
      price_suffix: 'game',
      geoblocked: false,
      preview: '/img/icon_softball.png',
      label: 'Softball',
      highlight: true,
    },
    'pednr9emk6dyguan8uyd': {
      name: 'Swimming - Div. II',
      price: 14.99,
      price_suffix: 'day',
      geoblocked: false,
      preview: '/img/icon_swimming.png',
      label: 'Swimming',
      highlight: true,
    },
    'uw8ncq5m5inwmquxtpgk': {
      name: 'Swimming - Div. I',
      price: 14.99,
      price_suffix: 'day',
      geoblocked: false,
      preview: '/img/icon_swimming.png',
      label: 'Swimming',
      highlight: true,
    },
    'jfzkqmfpriuq2gougj1f': {
      name: 'OHSAA Wrestling Dual Team Champ. - Full Access Pass',
      price: 19.99,
      price_suffix: 'day',
      geoblocked: false,
      preview: '/img/icon_wrestling.png',
      label: 'Wrestling',
      highlight: true,
    },
    'ulycwbg2ddjcg2ofigp7': {
      name: 'OHSAA Wrestling Individual Champ. - Full Access Pass',
      price: 19.99,
      price_suffix: 'day',
      geoblocked: false,
      preview: '/img/icon_wrestling.png',
      label: 'Wrestling',
      highlight: true,
    },
    'x0q9rrkp6nk9wekixzbm': {
      name: 'OHSAA Wrestling Champ. - Team Dual Divisional Mats',
      price: 9.99,
      price_suffix: 'mat',
      geoblocked: false,
      preview: '/img/icon_wrestling.png',
      label: 'Wrestling',
      highlight: true,
    },
    'hcgrbfafn56tkgyqygwz': {
      name: 'OHSAA Wrestling Champ. - Individual Divisional Mats',
      price: 9.99,
      price_suffix: 'mat',
      geoblocked: false,
      preview: '/img/icon_wrestling.png',
      label: 'Wrestling',
      highlight: true,
    },
    'lpqzt5iwelgtvpbnlj8b': {
      name: 'Girls Basketball',
      price: 9.99,
      price_suffix: 'game',
      geoblocked: false,
      preview: '/img/icon_basketball.png',
      label: 'Basketball',
      highlight: true,
    },
    'jvymxuo7qlnqp57jhgfw': {
      name: 'Boys Basketball',
      price: 9.99,
      price_suffix: 'game',
      geoblocked: false,
      preview: '/img/icon_basketball.png',
      label: 'Basketball',
      highlight: true,
    },
    'cpuf1riokhbvxqsdxxll': {
      name: 'Ice Hockey',
      price: 9.99,
      price_suffix: 'match',
      geoblocked: false,
      preview: '/img/icon_hockey.png',
      label: 'Hockey',
      highlight: true,
    },
    'pfhqvrjawpd89crteki9': {
      name: 'Track & Field',
      price: 14.99,
      price_suffix: 'day',
      geoblocked: false,
      preview: '/img/icon_track.png',
      label: 'Track & Field',
      highlight: true,
    },
    'wrkjficryo8lrqj3oy7a': {
      name: 'Soccer',
      price: 9.99,
      price_suffix: 'game',
      geoblocked: false,
      preview: '/img/icon_soccer.png',
      label: 'Soccer',
      highlight: true,
    },
    'adnv29epy7qy1rsaomwo': {
      name: 'Volleyball',
      price: 9.99,
      price_suffix: 'game',
      geoblocked: false,
      preview: '/img/icon_volleyball.png',
      label: 'Volleyball',
      highlight: true,
    },
};

const ohsaaChannels = {
  /*
    'wuucrbgoqvevv92axnjq': {
      name: 'Soccer',
      price: 9.99,
      price_suffix: 'game',
      geoblocked: false,
      preview: '/img/icon_soccer.png',
      label: 'Soccer',
      highlight: true,
    },
    'pvzf8fofkdfedpvg7uh3': {
      name: 'Volleyball',
      price: 9.99,
      price_suffix: 'game',
      geoblocked: false,
      preview: '/img/icon_volleyball.png',
      label: 'Volleyball',
      highlight: true,
    },
    'wpp2fgwbgvs88jkqpwwg': {
      name: '2018 Baseball Tournament',
      price: 9.99,
      price_suffix: 'game',
      geoblocked: false,
      preview: '/img/icon_baseball.png',
      label: 'Baseball',
      highlight: true,
    },
    'g4pkhif3is8iwqfxiihj': {
      name: '2018 Track & Field Championships Day 1',
      price: 14.99,
      price_suffix: 'day',
      geoblocked: false,
      preview: '/img/icon_track.png',
      label: 'Track & Field',
      highlight: true,
    },
    'nvpvhdiqxxa56pyq8pmw': {
      name: '2018 Track & Field Championships Day 2',
      price: 14.99,
      price_suffix: 'day',
      geoblocked: false,
      preview: '/img/icon_track.png',
      label: 'Track & Field',
      highlight: true,
    },
    */
};

Object.keys(spectrumChannels).forEach((k) => {
  var v = spectrumChannels[k];
  config.staticChannels.push({
    id: k, name: v.name, abbrev: v.label, accountId: spectrumAccountId,
  });
});
Object.keys(ohsaaChannels).forEach((k) => {
  var v = ohsaaChannels[k];
  config.staticChannels.push({
    id: k, name: v.name, abbrev: v.label, accountId: ohsaaAccountId,
  });
});

export default config;



// WEBPACK FOOTER //
// ./src/config.js